"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResizeObserver = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var resize_observer_polyfill_1 = tslib_1.__importDefault(require("resize-observer-polyfill"));
function useResizeObserver(ref) {
    var _a = tslib_1.__read(react_1.useState({}), 2), size = _a[0], setSize = _a[1];
    react_1.useEffect(function () {
        if (ref.current) {
            var resizeObserver_1 = new resize_observer_polyfill_1.default(function (entries) {
                requestAnimationFrame(function () {
                    if (!Array.isArray(entries) || !entries.length) {
                        return;
                    }
                    var target = entries[0].target;
                    var offsetWidth = target.offsetWidth, offsetHeight = target.offsetHeight;
                    setSize({ width: offsetWidth, height: offsetHeight });
                });
            });
            resizeObserver_1.observe(ref.current);
            return function () { return resizeObserver_1.disconnect(); };
        }
        return function () { };
    }, [ref]);
    return size;
}
exports.useResizeObserver = useResizeObserver;
//# sourceMappingURL=use-resize-observer.js.map